import { z } from "zod";
// ---------------------------------------------------------------------------
// Attachment — a photo or video carried by an archived Turn
// ---------------------------------------------------------------------------
export const AttachmentKindSchema = z.enum(["image", "video"]);
/**
 * Attachment as exposed to clients.
 *
 * `url` / `thumbUrl` are short-lived HMAC-signed URLs on the dedicated files
 * origin — never on the API origin, which carries the refresh cookie. They
 * expire (FILES_URL_TTL_SECONDS), so a client holding a stale history must
 * re-fetch rather than cache them indefinitely.
 *
 * Both are absent when `expired` is true: the blob was purged once the disk hit
 * saturation. The Turn's text survives; only the media is gone.
 */
export const AttachmentSchema = z.object({
    id: z.string().uuid(),
    kind: AttachmentKindSchema,
    mimeType: z.string().min(1),
    fileName: z.string().min(1),
    sizeBytes: z.number().int().positive(),
    width: z.number().int().positive().optional(),
    height: z.number().int().positive().optional(),
    durationMs: z.number().int().positive().optional(),
    url: z.string().url().optional(),
    thumbUrl: z.string().url().optional(),
    expired: z.boolean().default(false),
});
/** Response of POST /v1/sessions/:sessionId/attachments */
export const UploadAttachmentResponseSchema = AttachmentSchema;
//# sourceMappingURL=attachment.js.map